import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import CaseStudy from "../../images/industries/fintech/Fintech-casestudy-app.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Globalmarket(props) {
  return (
    <section className="tekrevol_dark_bg  tekgrip_img_uper fintech-save-sec  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="example" data-text="Save & Win">
              <h2>Save & Win</h2>
            </div>
            <p>
              Save & Win is a mobile application that encourages users to save
              money and get rewarded for it. This type of money-saving
              application allows users to compare the prices of their favorite
              products available online and lets them know how much they’re
              saving on each project.
            </p>
            <div className="btn_talk">
              <Link
                to="/case-studies/save-win"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                View Full Case Study
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            <div className="tekgrip_tabs_image">
              <LazyLoadImage
                src={CaseStudy}
                effect="blur"
                alt="fintech solutions software development company"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Globalmarket;
